import { Reducer } from '@reduxjs/toolkit';
import {
  GET_AVATAR_TYPE_REF,
  GET_DOCUMENT_REF,
  GET_EMPLOYMENT_DOC_TYPE_REF,
  GET_LEVEL_BUSINESS_REF,
  GET_META_SKILL_REF,
  GET_OLYMPIAD_SUBJECTS_REF,
  GET_PROFESSION_RANK_REF,
  GET_PROFESSIONAL_PROGRAMM_REF,
  GET_SALARY_RANGE_REF,
  GET_SECTION_REF,
  GET_SPO_GIA_MARK_REF,
  GET_SPO_ORGANIZATION_REF,
  GET_SPORT_AGES_REF,
} from 'actions';
import { FAILURE, REQUEST, SUCCESS } from 'actions/utils';
import {
  DocumentRefItem,
  IBaseRefItem,
  ICommonResponse,
  MetaSkillRefItem,
  ProfessionProgrammRefItem,
  SectionRefItem,
  SportAgeRefItem,
} from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

type RefState<T> = ICommonResponse<T>;

const createRefReducer = <T>(actions: Record<string, string>): Reducer<RefState<T>> => {
  const initialState: RefState<T> = {
    content: [],
    loading: false,
  };
  const generic = genericReducers<RefState<T>>();
  const reducer: IReducers<RefState<T>> = {
    [actions[REQUEST]]: generic.get.request,
    [actions[SUCCESS]]: generic.get.success,
    [actions[FAILURE]]: generic.get.failure,
  };

  return connectReducers(initialState, reducer);
};

export type SectionRefState = RefState<SectionRefItem>;
export type DocumentRefState = RefState<DocumentRefItem>;
export type MetaSkillRefState = RefState<MetaSkillRefItem>;
export type ProfessionProgrammRefState = RefState<ProfessionProgrammRefItem>;
export type LevelBusinessRefState = RefState<IBaseRefItem>;
export type SalaryRangeRefState = RefState<IBaseRefItem>;
export type EmploymentDocTypeRefState = RefState<IBaseRefItem>;
export type SpoOrganizationRefState = RefState<IBaseRefItem>;
export type SpoGiaMarkRefState = RefState<IBaseRefItem>;
export type ProfessionRankRefState = RefState<IBaseRefItem>;
export type SportAgesRefState = RefState<SportAgeRefItem>;
export type OlympiadSubjectsRefState = RefState<IBaseRefItem>;
export type AvatarTypeRefState = RefState<IBaseRefItem>;

export const sectionRef = createRefReducer<SectionRefItem>(GET_SECTION_REF);
export const documentRef = createRefReducer<DocumentRefItem>(GET_DOCUMENT_REF);
export const metaSkillRef = createRefReducer<MetaSkillRefItem>(GET_META_SKILL_REF);
export const professionProgrammRef = createRefReducer<ProfessionProgrammRefItem>(GET_PROFESSIONAL_PROGRAMM_REF);
export const levelBusinessRef = createRefReducer<IBaseRefItem>(GET_LEVEL_BUSINESS_REF);
export const salaryRangeRef = createRefReducer<IBaseRefItem>(GET_SALARY_RANGE_REF);
export const employmentDocTypeRef = createRefReducer<IBaseRefItem>(GET_EMPLOYMENT_DOC_TYPE_REF);
export const spoOrganizationRef = createRefReducer<IBaseRefItem>(GET_SPO_ORGANIZATION_REF);
export const spoGiaMarkRef = createRefReducer<IBaseRefItem>(GET_SPO_GIA_MARK_REF);
export const professionRankRef = createRefReducer<IBaseRefItem>(GET_PROFESSION_RANK_REF);
export const sportAgesRef = createRefReducer<SportAgeRefItem>(GET_SPORT_AGES_REF);
export const olympiadSubjectsRef = createRefReducer<IBaseRefItem>(GET_OLYMPIAD_SUBJECTS_REF);
export const avatarTypeRef = createRefReducer<IBaseRefItem>(GET_AVATAR_TYPE_REF);
